














import { Component, Vue } from 'vue-property-decorator';

import { Store } from '@/enums/Store';

import { User } from '@/util/User';

import { namespace } from 'vuex-class';

import UserOverview from '@/components/Overview/UserOverview.vue';

const INVOICE_RECIPIENT = namespace(Store.INVOICE_RECIPIENT);
const CUSTOMER = namespace(Store.CUSTOMER);

@Component({
  components: { UserOverview }
})
export default class BillingOverview extends Vue {
  @INVOICE_RECIPIENT.State('invoiceRecipient') invoiceRecipient?: User;
  @CUSTOMER.State('customer') customer?: User;
}
